import { Component, OnInit } from '@angular/core';
import { ctwrInfo } from './ctwr.config';
import { AuthenticationService } from '../../auth.service';
import { Router, NavigationEnd, RouterEvent } from '@angular/router';
import { Location } from '@angular/common';
import { AppService } from '../../app.service';
import { Subject } from 'rxjs';
import { getEnv } from 'src/modules/utility';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-ctwr',
  templateUrl: './ctwr.component.html',
  styleUrls: ['./ctwr.component.scss'],
  host: { 'class': 'router-outlet' },
})
export class CtwrComponent implements OnInit {
  config: any = ctwrInfo;
  isAdminRoute: boolean;
  isCtwrUser: boolean;
  trainingUrl: string = ctwrInfo.trainingUrl;
  constructor(
    public readonly authService: AuthenticationService,
    public readonly router: Router,
    private readonly location: Location,
    private readonly appService: AppService,
  ) { }


  ngOnInit() {
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: RouterEvent) => this.validateRoute(e.url));
    this.validateRoute(this.router.url);
    this.isCtwrUser = this.authService.getUserRoles().some(r => r.startsWith('CTWR'));
  }

  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  /**
   * 
   */
  onBack = () => this.location.back();


  /** 
   * 
   */
  validateRoute = (url: string) => {
    const pathEnd = url.split('/').pop().replace('-', ' ');
    this.appService.viewTitle = pathEnd;
    this.isAdminRoute = pathEnd.toLowerCase().includes('admin');
  }

  getLegacyUrl(): string {
    return ctwrInfo.legacyUrl[getEnv()];
  }


  public get title(): string {
    return this.appService.viewTitle;
  }

}
